module.exports = __webpack_public_path__ + "static/media/chicken-nuggets-mb-fr.f864e773.jpg";